import { Dispatch, SetStateAction } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function SnackBar({ open, setOpen, message, isSuccess }: { 
    open: boolean, 
    setOpen: Dispatch<SetStateAction<boolean>>, 
    message: string,
    isSuccess: boolean,
}) {


  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert
            onClose={handleClose}
            severity={isSuccess ? 'success' : 'error'}
            // variant="filled"
            sx={{ width: '100%', fontSize: '14px', fontFamily: 'Montserrat' }}
          >
            {message}
          </Alert>
      </Snackbar>
    </div>
  );
}